export const getActiveUser = (user) => {
  let isChecked = false;

  if (user?.enabled && !user?.temporaryLocked) {
    isChecked = true;
  }

  if (!user?.enabled || user?.temporaryLocked) {
    isChecked = false;
  }

  return isChecked;
};
